import { useState } from 'preact/hooks';
import { Icone } from '../icones';
import { ehIos, instalar, mostrarInstalar, podeInstalar } from '../pwa';
import { Modal } from '../ui';

/** "Instalar app": abre o diálogo do navegador; no iPhone, mostra o passo a passo. Some sozinho se já está instalado. */
export function BotaoInstalar({ class: classe = 'botao', rotulo = 'Instalar app', aoClicar }: { class?: string; rotulo?: string; aoClicar?: () => void }) {
  const [ajudaIos, setAjudaIos] = useState(false);
  if (!mostrarInstalar.value) return null;

  async function clicar() {
    aoClicar?.();
    if (podeInstalar.value) await instalar();
    else if (ehIos) setAjudaIos(true);
  }

  return (
    <>
      <button type="button" class={classe} onClick={() => void clicar()}>
        <Icone nome="instalar" tamanho={18} /> {rotulo}
      </button>
      {ajudaIos && (
        <Modal titulo="Instalar no iPhone / iPad" onFechar={() => setAjudaIos(false)} pequeno>
          <ol class="passos-instalar">
            <li>Abra este endereço no <strong>Safari</strong>.</li>
            <li>Toque em <strong>Compartilhar</strong> (o quadrado com a seta para cima).</li>
            <li>Escolha <strong>Adicionar à Tela de Início</strong> e confirme.</li>
          </ol>
          <div class="modal-acoes"><button type="button" class="botao primario" onClick={() => setAjudaIos(false)}>Entendi</button></div>
        </Modal>
      )}
    </>
  );
}
